<template lang="html">
    <div class="field" v-if="sixthStep">
        <label>Setari implicite</label>
        <div class="checkboxes">
            <UiCheckbox
                label="PROGRĂMARI"
                :id="1"
                class="item__checkbox"
                :checked="sixthStep.appointments == true"
                @input="
                    emitActiveButton($event), 
                    $store.state.settings.steps[5].payload.appointments = $event
                "/>
            
            <UiCheckbox
                label="ȘEDINȚE ANYTIME"
                :id="2"
                :checked="sixthStep.anytimeServices == true"
                @input="
                    emitActiveButton($event), 
                    $store.state.settings.steps[5].payload.anytimeServices = $event
                "/>
        </div>

        <div class="timetable-picker">
            <label>Selecteaza o zi</label>
            <div class="timetable-picker__days" ref="firstTimetableItem">
                <div
                    v-for="day in days"
                    :key="day"
                    class="timetable-picker__day"
                    :class="{
                        'timetable-picker__day__disabled': errors[selectedDay(selectedDayIndex).day_en].length > 0,
                        'timetable-picker__day__active': day == selectedDayIndex
                    }"
                    @click="changeDay(day)">
                    <span>{{selectedDay(day).day_letter}}</span>
                </div>
            </div>

            <div class="timetable-picker__intervals__head">
                <label v-if="$store.state.settings.steps[5].payload.timetable[selectedDay(selectedDayIndex).day_en]">
                    Intervale de timp ({{$store.state.settings.steps[5].payload.timetable[selectedDay(selectedDayIndex).day_en].length}})
                </label>
                <i v-if="sixthStep.timetable[selectedDay(selectedDayIndex).day_en]
                    && sixthStep.timetable[selectedDay(selectedDayIndex).day_en].length == 1"
                    class="fas fa-plus-circle timetable-picker__interval__add"
                    @click="addTimetableInterval">
                </i>
                <i v-if="sixthStep.timetable[selectedDay(selectedDayIndex).day_en]
                    && sixthStep.timetable[selectedDay(selectedDayIndex).day_en].length == 0"
                    class="fas fa-plus-circle timetable-picker__interval__add"
                    @click="addTimetableInterval"></i>
            </div>

            <div class="timetable-picker__intervals">
                <div v-if="sixthStep.timetable[selectedDay(selectedDayIndex).day_en]
                    && sixthStep.timetable[selectedDay(selectedDayIndex).day_en].length == 0">
                    <div class="timetable-picker__interval">
                        <span class="timetable-picker__interval">INDISPONIBIL</span>
                    </div>
                </div>
                <div v-if="sixthStep.timetable[selectedDay(selectedDayIndex).day_en]"
                    v-for="(day, index) in sixthStep.timetable[selectedDay(selectedDayIndex).day_en]"
                    :key="index" class="timetable-picker__interval">

                    <template v-if="index==0">
                        <div class="timepicker-container">
                            <span>Început</span>
                            <vue-timepicker debug-mode
                                drop-direction="up"
                                hour-label="Oră"
                                minute-label="Minut"
                                format="HH:mm"
                                :minute-interval="5"
                                v-model="sixthStep.timetable[selectedDay(selectedDayIndex).day_en][index].start_time"
                                @close="intervalsNotOverlaping(index)">
                            </vue-timepicker>
                        </div>
                        <div class="timepicker-container">
                            <span>Sfârșit</span>
                            <vue-timepicker debug-mode
                                drop-direction="up"
                                hour-label="Oră"
                                minute-label="Minut"    
                                format="HH:mm"
                                :minute-interval="5"
                                :hour-range="getHoursRangeFirstEnd"
                                v-model="sixthStep.timetable[selectedDay(selectedDayIndex).day_en][index].end_time"
                                @close="intervalsNotOverlaping(index)">
                            </vue-timepicker>
                        </div>
                    </template>
                    
                    <template  v-if="index==1">
                        <div class="timepicker-container">
                            <span>Inceput</span>
                            <vue-timepicker debug-mode
                                drop-direction="up"
                                hour-label="Oră"
                                minute-label="Minut"
                                format="HH:mm"
                                :minute-interval="5"
                                :hour-range="getHoursRangeSecondStart"
                                v-model="sixthStep.timetable[selectedDay(selectedDayIndex).day_en][index].start_time"
                                @close="intervalsNotOverlaping(index)">
                            </vue-timepicker>
                        </div>
                        <div class="timepicker-container">
                            <span>Sfârșit</span>
                            <vue-timepicker debug-mode
                                drop-direction="up"
                                hour-label="Oră"
                                minute-label="Minut"
                                format="HH:mm"
                                :minute-interval="5"
                                :hour-range="getHoursRangeSecondEnd"
                                v-model="sixthStep.timetable[selectedDay(selectedDayIndex).day_en][index].end_time"
                                @close="intervalsNotOverlaping(index)">
                            </vue-timepicker>
                        </div>
                    </template>
                    <div class="timepicker-container">
                        <!-- <span>Sfarsit</span> -->
                        <i class="fas fa-times-circle timetable-picker__interval__remove"
                            @click="removeTimetableInterval(index)">
                        </i>
                    </div>
                </div>
            </div>
            <p class="timetable-picker__error" v-if="errors[selectedDay(selectedDayIndex).day_en]">
                {{errors[selectedDay(selectedDayIndex).day_en]}}
            </p>
        </div>
    </div>
</template>

<script>
import UiInput from '@/components/ui/Input'
import UiCheckbox from '@/components/ui/Checkbox'
import { mapGetters } from 'vuex'
import VueTimepicker from 'vue2-timepicker'
import 'vue2-timepicker/dist/VueTimepicker.css'

export default {
    components: {
        UiInput,
        UiCheckbox,
        VueTimepicker
    },
    data() {
        return {
            errors: {
                monday: '',
                tuesday: '',
                wednesday: '',
                thursday: '',
                friday: '',
                saturday: '',
                sunday: ''
            },
            apiErrors: [],
            days: [1, 2, 3, 4, 5, 6, 7],
            selectedDayIndex: 1,
            currentTimeObject: {}
        };
    },
    computed: {
        ...mapGetters({
            sixthStep: 'settings/sixthStep'
        }),
        getHoursRangeFirstEnd() {
            var currentInterval = this.$store.state.settings.steps[5].payload.timetable[this.selectedDay(this.selectedDayIndex).day_en][0];
            if(currentInterval && currentInterval.start_time) {
                var result = [];
                for(var i = currentInterval.start_time.HH; i <= 23; i++) {
                    result.push(i);
                }
                return result;
            }
            return [];
        },
        getHoursRangeSecondStart() {
            var currentInterval = this.$store.state.settings.steps[5].payload.timetable[this.selectedDay(this.selectedDayIndex).day_en][0];
            if(currentInterval && currentInterval.end_time) {
                var result = [];
                for(var i = currentInterval.end_time.HH; i <= 23; i++) {
                    result.push(i);
                }
                return result;
            }
            return [];
        },
        getHoursRangeSecondEnd() {
            var currentInterval = this.$store.state.settings.steps[5].payload.timetable[this.selectedDay(this.selectedDayIndex).day_en][1];
            if(currentInterval && currentInterval.start_time) {
                var result = [];
                for(var i = currentInterval.start_time.HH; i <= 23; i++) {
                    result.push(i);
                }
                return result;
            }
            return [];
        }
    },
    mounted() {
        this.$emit('activeButton', false);
    },
    methods: {
        selectedDay: function (daynr) {
          let todayDateNr = daynr;
          switch(todayDateNr){
              case 1:
                return {
                    'day_number': 1,
                    'day_en': 'monday',
                    'day_letter': 'L' //RO LANG
                }
                break;
            case 2:
                return {
                    'day_number': 2,
                    'day_en': 'tuesday',
                    'day_letter': 'M' //RO LANG
                }
                break;
            case 3:
                return {
                    'day_number': 3,
                    'day_en': 'wednesday',
                    'day_letter': 'Mi' //RO LANG
                }
                break;
            case 4:
                return {
                    'day_number': 4,
                    'day_en': 'thursday',
                    'day_letter': 'J' //RO LANG
                }
                break;
            case 5:
                return {
                    'day_number': 5,
                    'day_en': 'friday',
                    'day_letter': 'V' //RO LANG
                }
                break;
            case 6:
                return {
                    'day_number': 6,
                    'day_en': 'saturday',
                    'day_letter': 'S' //RO LANG
                }
                break;
            case 7:
                return {
                    'day_number': 7,
                    'day_en': 'sunday',
                    'day_letter': 'D' //RO LANG
                }
                break;
            }
        },
        changeDay(index) {
            var current = this.sixthStep.timetable[this.selectedDay(this.selectedDayIndex).day_en];
            
            if(current[0])
                this.validFormatInterval(current[0]);
                
            if(current[1])
                this.validFormatInterval(current[1]);
            
            if(this.errors[this.selectedDay(this.selectedDayIndex).day_en].length <= 0)
                this.selectedDayIndex = index;
        },
        removeTimetableInterval(index) {
            
            if(index == 0 && this.intervalsNotOverlaping(1)) {
                this.errors[this.selectedDay(this.selectedDayIndex).day_en] = 'Inerval incorect!';
                return;
            }
            
            if(index == 1 && this.intervalsNotOverlaping(0)) {
                this.errors[this.selectedDay(this.selectedDayIndex).day_en] = 'Inerval incorect!';
                return;
            }
                
            this.$store.state.settings.steps[5].payload.timetable[this.selectedDay(this.selectedDayIndex).day_en].splice(index, 1);
            this.intervalsNotOverlaping(index);
            
            this.errors[this.selectedDay(this.selectedDayIndex).day_en] = '';
        },
        addTimetableInterval() {
            var interval = {
                start_time: null,
                end_time: null
            };
            this.$store.state.settings.steps[5].payload.timetable[this.selectedDay(this.selectedDayIndex).day_en].push(interval);
            this.$emit('activeButton', false);
        },
        validFormatInterval(interval) {
            
            if(!interval.start_time || !interval.end_time) {
                this.errors[this.selectedDay(this.selectedDayIndex).day_en] = 'Inerval incorect!';
                return false;
            }
            if(!interval.start_time.HH || !interval.start_time.mm) {
                this.errors[this.selectedDay(this.selectedDayIndex).day_en] = 'Inerval incorect!';
                return false;
            }
                
            if(!interval.end_time.HH || !interval.end_time.mm) {
                this.errors[this.selectedDay(this.selectedDayIndex).day_en] = 'Inerval incorect!';
                return false;
            }
            
            if(!interval.start_time || !interval.end_time) {
                this.errors[this.selectedDay(this.selectedDayIndex).day_en] = 'Inerval incorect!';
                 return false;
            }
            else
                if(interval.start_time.HH && interval.start_time.mm)
                    if(!interval.start_time.HH.length||!interval.start_time.mm.length||!interval.end_time.HH.length||!interval.end_time.mm.length)
                        return false;
                else
                    if(interval.start_time.HH > interval.end_time.HH)
                        return false;
                    else if(interval.start_time.HH == interval.end_time.HH && interval.start_time.mm > interval.end_time.mm)
                        return false;
                    else return true;
            return true;
        },
        intervalsNotOverlaping(index) {
            
            var current = this.sixthStep.timetable[this.selectedDay(this.selectedDayIndex).day_en];
            
            if(current[0])
                this.validFormatInterval(current[0]);
                
            if(current[1])
                this.validFormatInterval(current[1]);
                
            var interval1 = this.$store.state.settings.steps[5].payload.timetable[this.selectedDay(this.selectedDayIndex).day_en][0];
            var interval2 = this.$store.state.settings.steps[5].payload.timetable[this.selectedDay(this.selectedDayIndex).day_en][1];
            
            if(interval1 && interval1.start_time && interval1.end_time && !interval2) {
                if(this.validFormatInterval(interval1)) {
                    this.$emit('activeButton', true);
                    this.errors[this.selectedDay(this.selectedDayIndex).day_en] = '';
                } else {
                    this.errors[this.selectedDay(this.selectedDayIndex).day_en] = 'Inerval incorect!';
                    this.$emit('activeButton', false);
                }
            } else if(interval1 && interval1.start_time && interval1.end_time && interval2 && interval2.start_time && interval2.end_time) {
                if(this.validFormatInterval(interval1) && this.validFormatInterval(interval2)) {
                    var data = {
                        start_time: interval1.end_time,
                        end_time: interval2.start_time
                    };

                    if(this.validFormatInterval(data) == true) {
                        this.$emit('activeButton', true);
                        this.errors[this.selectedDay(this.selectedDayIndex).day_en] = '';
                    } else {
                        this.errors[this.selectedDay(this.selectedDayIndex).day_en] = 'Inerval incorect!';
                        this.$emit('activeButton', false);
                    }
                    
                } else {
                    this.errors[this.selectedDay(this.selectedDayIndex).day_en] = 'Inerval incorect!';
                    this.$emit('activeButton', false);
                }
            }
        },
        emitActiveButton(event) {
            var current = this.sixthStep.timetable[this.selectedDay(this.selectedDayIndex).day_en];
            
            if(current[0])
                this.validFormatInterval(current[0]);
                
            if(current[1])
                this.validFormatInterval(current[1]);
                
            if(this.errors[this.selectedDay(this.selectedDayIndex).day_en].length == 0)
                this.$emit('activeButton', true);
        },
    },
    watch: {
        "$store._modules.root.state.notification.notification"(notification) {
            if(notification.icon == 'error' && this.$store._modules.root.state.settings.currentStep == 5) {
                this.errors = [];
                this.apiError = notification;
            }
		}
    }
}
</script>

<style lang="scss" scoped>

.checkboxes {
    display: flex;
    flex-direction: row;
}

.list {
    width: 100%;
    margin: 20px 0px;

    &__item {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        margin: 20px 0px;
        display: flex;
        justify-content: center;
        align-items: center;
        
        &__iterval {
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            margin: 20px 0px;
        }

        &__text {
            font-family: Roboto;
            font-style: normal;
            font-weight: 500;
            font-size: 16px;
            display: flex;
            align-items: center;
            text-align: center;
            margin-top: 5px;
        }

        &__checkbox {
            position: absolute;
            left: 50%;
            top: 50%;
            transform: translate(-50%, -50%);
        }
    }
}

.timetable-picker {
    margin: 20px 0 0 0;

    &__days {
        display: flex;
        flex-direction: row;
        flex-wrap: nowrap;
        justify-content: flex-start;
        overflow: auto;
        padding: 10px 10px 10px 0px;
    }

    &__day {
        display: flex;
        width: 38px;
        height: 38px;
        border-radius: 50%;
        margin: 10px;
        min-width: 45px;
        height: 45px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        text-align: center;
        cursor: pointer;
        border: 1px solid $color-primary;

        span {
            margin: auto;
            color: $color-primary;
            font-size: 20px;
        }

        &__active {
            background-color: $color-primary;
            cursor: pointer;
            span {
                color: $color-light;
            }
        }

        &__disabled {
            background-color: $color-light-gray;
            cursor: not-allowed;

            span {
                color: $color-primary;
            }
        }
    }

    &__intervals {
        margin-top: 20px;

        &__head {
            margin-top: 20px;
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            position: relative;
            width: 100%;

            label {
                margin: 0;
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%); 
                width: 100%;   
            }
            i {
                margin: 0;
                position: absolute;
                top: 50%;
                right: -10px;
                transform: translate(-50%, -50%);     
            }
        }
    }

    &__interval {
        padding: 5px 10px;
        display: flex;
        justify-content: space-between;
        width: auto;

        &__add {
            font-size: 40px;
            color: $color-secondary;
            cursor: pointer;
        }
        
        &__remove {
            font-size: 40px;
            color: $color-danger;
            margin-top: 20px;
            cursor: pointer;
        }
    }

    &__error {
        color: $color-danger;
        margin: 10px 0 0 10px;
        text-align: center;
    }
}

@media only screen and (max-width: 350px) {
    .checkboxes {
        flex-direction: column;
    }
}
</style>

<style lang="scss">
    input[type="time"]::-webkit-calendar-picker-indicator {
        display: none;
    }
    .vue__time-picker {
        width: auto;
    }
    .vue__time-picker input.display-time {
        padding: 3px 10px;
        height: 40px !important;
        max-width: 10em !important;
        width: 100%;
        cursor: pointer;
        outline: none;
        font-size: 15px;
        border: 1px solid $color-primary;
        text-align: center; 
    }
    .vue__time-picker .dropdown ul li:not([disabled]).active, .vue__time-picker .dropdown ul li:not([disabled]).active:focus, .vue__time-picker .dropdown ul li:not([disabled]).active:hover {
        background: $color-primary !important;
    }
    .controls {
        /* right: 10px!important; */
        display: none !important;
    }
    .timepicker-container {
        display: flex;
        flex-direction: column;

        span {
            margin: 0 0 5px 0;
        }
    }
</style>